module.exports = __webpack_public_path__ + "img/homemid2.6897025f.png";